import { lazy } from "react";

export const WordPage = lazy(() => import("./ui/WordPage"));
